import React from 'react';
import { Link, MenuItem, MenuList } from '@mui/material';
import { useTranslation } from 'i18n';
import MenuButton from 'components/common/MenuButton';
import { makeStyles } from 'tss-react/mui';
import { alpha } from '@mui/material/styles';
import addToCalendarData from './addToCalendarData';

interface CalendarMenuProps {
  event: any;
  open: boolean;
}

const useStyles = makeStyles()((theme) => ({
  menuItem: {
    // padding: theme.spacing(0, 2),
    minWidth: '193px',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.07),
    },
  },
}));

const AddToCalendarMenu: React.FC<React.PropsWithChildren<CalendarMenuProps>> = ({ open, event }) => {
  const [t] = useTranslation('public');
  const { classes } = useStyles();

  return (
    <MenuList autoFocusItem={open}>
      {Object.keys(addToCalendarData).map((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const { icon, route } = addToCalendarData[key];
        return (
          <MenuItem className={classes.menuItem} key={key} component={Link} target="_blank" {...route(event)}>
            <MenuButton
              style={{ textTransform: 'capitalize', fontSize: 15, fontWeight: 500 }}
              color="inherit"
              disableFocusRipple
              disableRipple
              startIcon={icon}
            >
              {t<string>('event.addToCalendarMenu.item', { context: key })}
            </MenuButton>
          </MenuItem>
        );
      })}
    </MenuList>
  );
};

export default AddToCalendarMenu;
